import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { LPXv1_ABI } from "./abi/LPXv1_ABI";

export class LPXInfo{
    public configs_:LPXConfig[];
    public reserves_:LPXReserves[];
}
export class LPXReserves{
    public fundReserve:bigint;
    public fundImgReserve:bigint;
    public anchorReserve:bigint;
    public anchorImgReserve:bigint;
}
export class LPXShare{
    public share:bigint;
    public debt:bigint;
    public pending:bigint;
}
export class LPXShareInfo{
    public debt:bigint;
    public pending:bigint;
}
export class LPXConfig{
    public pack:bigint;
    public manager:string;
    public fundToken:bigint;
    public anchorToken:bigint;
    // public ntzIndex:string;
    // public rewardIndex:string;
    // public startRatio:string;
    // public sellRatio:string;
    public totalShares:bigint;
    // public lastStartDropTimestamp:string;
}

        // uint256 pack;

        // address manager; //управляющий пулом
        // uint256 fundToken;
        // uint256 anchorToken;

        // uint256 totalShares; //Сумма всех долей 

export class LPXContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, LPXv1_ABI.GetABI(), provider);
    }



    async getPoolsByIds(poolsIds:number[]): Promise<LPXInfo>
    {
        const response = await this._call("getPoolsByIds", poolsIds);
        if (!response) return;
        const pools = response as LPXInfo;
        const result = new LPXInfo();
        result.reserves_ = [];
        result.configs_ = [];
        for(let i=0;i<pools.configs_.length;i++)
        {
            let reserve = pools.reserves_[i];
            let config = pools.configs_[i];
            const res = new LPXReserves();
            res.fundReserve = reserve.fundReserve;
            res.fundImgReserve = reserve.fundImgReserve;
            res.anchorReserve = reserve.anchorReserve;
            res.anchorImgReserve = reserve.anchorImgReserve;
            result.reserves_.push(res);
            const cfg = new LPXConfig();
            cfg.pack = config.pack;
            cfg.manager = config.manager;
            cfg.fundToken = config.fundToken;
            cfg.anchorToken = config.anchorToken;
            // cfg.ntzIndex = this._toDecimal(config.ntzIndex);
            // cfg.rewardIndex = this._toDecimal(config.rewardIndex);
            // cfg.startRatio = this._toDecimal(config.startRatio);
            // cfg.sellRatio = this._toDecimal(config.sellRatio);
            cfg.totalShares = config.totalShares;
            result.configs_.push(cfg);
        }
        return result;
    }

    async lastPoolId()
    {
        return await this._call("lastPoolId");
    }

    async shares(poolId:number, address:string): Promise<LPXShare>
    {
        const res = await this._call("shares", poolId, address);
        if (!res) return;
        const share = res as LPXShare;
        const result = new LPXShare();
        result.share = res.share;
        result.pending = res.pending;
        result.debt = res.debt;
        return result;
    }

    // async addLiquidity(poolId:number, fundValueEth:string, anchorValueEth:string): Promise<any>
    // {
        
    //     const result = await this._send('addLiquidity', poolId, this._toWei(fundValueEth), this._toWei(anchorValueEth)); 
    //     return result;
    // }

    // async removeLiquidity(poolId:number, partEth:string): Promise<any>
    // {
    //     const result = await this._send('removeLiquidity', poolId+"", this._web3.utils.toWei(partEth, "ether")); 
    //     return result;
    // }
}